import crud from '@/crud/form/form'
import resources from '../../resources'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/form/resources/index.js